<div class="mission-control">
    <!-- navbar -->
    @if(showNavigation()) {
    <app-navigation></app-navigation>
    }

    <!-- breadcrumbs -->
    <!-- <app-breadcrumb></app-breadcrumb> -->

    <!-- router outlet here -->
    <p-confirmDialog />
    @if (currentUrl().includes('photobooth')) {
        <div class="w-full h-[100dvh] overflow-hidden">
            <router-outlet></router-outlet>
        </div>
    } @else {
        <div>
            <p-splitter [panelSizes]="splitterPanelSizes()" [minSizes]="minDatapadSizes" appScrollManager>

                <ng-template pTemplate>
                    <div class="w-full pt-1 md:pl-3 md:pt-3">
                        <div class="overflow-y-auto" [style]="{height: dataPadHeight()}">
                            <router-outlet></router-outlet>
                        </div>
                        <!-- <p-scrollPanel [style]="{height: dataPadHeight()}">
                         
                        </p-scrollPanel> -->
                    </div>
                </ng-template>

                <ng-template pTemplate>

                    <div class="shadow-lg w-full pt-1">
                        <p-scrollPanel [style]="{height: dataPadHeight()}">
                            <app-data-pad (countChange)="dataPadCountChange($event)"></app-data-pad>
                        </p-scrollPanel>
                    </div>

                </ng-template>

            </p-splitter>
           
        </div>
    }
    <!-- footer here -->

</div>